import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-controle-service',
  imports: [RouterLink],
  templateUrl: './controle-service.component.html',
  styleUrl: './controle-service.component.scss',
})
export class ControleServiceComponent {

}
